import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { fromEvent } from 'rxjs';
import { SvcServices }  from './svc.service';
import { windowService } from './window.service';
import { AdobePageData } from 'app/models';
import { AdobeTriggerService } from './adobe-trigger.service';


//import { Cookie } from 'ng2-cookies/ng2-cookies';

type siteCatEventType = 'load' | 'viewDisplayed' | 'dmarAdsLoaded';

@Injectable()
export class AdobeService {

      // static readonly DOMAIN: String = window.location.hostname;

      private window: any;
      private svcService: any;
      private globalData: any;
      private detailedPageName: string;
      private pageLoaded: boolean = false;
      private pageName: string;

      private siteCatEventValueMap: any = {
            load: 'fusionPageLoad',
            viewDisplayed: 'fusionModuleViewDisplayed',
            formInteraction: 'fusionFormInteraction',
            dmarAdsLoaded: 'fusionDmarAdsLoaded',
            dmarAdInteraction: 'fusionDmarAdInteraction',
            mpdTooltipInteraction: 'fusionMinPaymentDueTooltipInteraction',
            cardSelectorInteraction: 'fusionCardSelectorInteraction',
            speedbumpContinue: 'fusionSpeedbumpContinue',
            speedbumpCancel: 'fusionSpeedbumpCancel',
            speedbumpDisplay: 'fusionSpeedbumpDisplay',
            customDropdownInteraction: 'fusionCustomDropdownInteraction',
            customFormInteraction: 'fusionCustomFormInteraction',
            customFormSubmission: 'fusionCustomFormSubmission',
        	linkClick: 'fusionLinkClick',
            customMinorInteraction: 'fusionCustomMinorInteraction',
            customError: 'fusionCustomError',
            customPageView: 'fusionCustomPageView',
      }

      private siteCatFormMap: any = {
            TEXT: 'text',
            CHECKBOX: 'checkbox',
            RADIO: 'radio',
            ANCHOR: 'A'
      }

      constructor(private _window: windowService, private _svcService: SvcServices, private _triggerService: AdobeTriggerService) {
            this.window = _window.nativeWindow;
            this.svcService = _svcService;
            this._svcService.isSignOnLoaded.subscribe((data)=>{
                  if(data) {
                        this.pageLoaded = true;
                  }
            });
      }
      /**
      *  This is a public method exposed to set page level data to be passed to site catalyst.
      *
       */

      public setSCPageData(eventType: String, pageData: AdobePageData, eventObject?: any) {

            //attaching passed in variables to the dataLayer
            //Object.assign(this.window._dl, pageData);

            //PCR013 -Start
            this.pageName = sessionStorage?.getItem("isSingleSignon") === "true" ? "single_sign_on" : "sign_on";
            if(this.getQueryStringVariable("siteId").toUpperCase() === "PLCN_SYW") {

                  if (eventType == "load" && (pageData && pageData.speedbumpStatus && pageData.speedbumpStatus === 'cancel')) {
                        pageData = {page_name: this.pageName};
                        this.window._dl.test_id = "GNADT-7045";
                        this.window._dl.marketing_modules = "";
                  } else if (eventType == "load" && !(pageData && pageData.speedbumpStatus && pageData.speedbumpStatus === 'cancel')) {
                        this.window._dl.test_id = "GNADT-7696";
                        this.window._dl.marketing_modules = null;
                  }
                  else if (eventType != "load" && (pageData && pageData.speedBumpType && pageData.speedBumpType === 'pcr013')) {
                        this.window._dl.test_id = "GNADT-7696";
                        this.window._dl.button_id_type = pageData.buttonType;
                        this.window._dl.marketing_modules = "";
                  }
                  else {
                        pageData = {page_name: this.pageName};
                        this.window._dl.test_id = sessionStorage?.getItem("isSingleSignon") === "true" ? "GNADT-7689" : "GNADT-7045";
                        this.window._dl.marketing_modules = "";
                  }
                  // if(pageData && pageData.speedBumpType && pageData.speedBumpType === 'pcr013') {
                  //       this.window._dl.test_id = "GNADT-7696";
                  // }
            } else {
                  pageData = {page_name: this.pageName};
                  this.window._dl.test_id = sessionStorage?.getItem("isSingleSignon") === "true" ? "GNADT-7689" : "GNADT-7045";
                  this.window._dl.marketing_modules = "";
            }
            //PCR013 - End

            if (!this.globalData)
                  this.setGlobalData();

            //attaching additional variables from this file to the dataLayer
            this.window._dl.site_id = this.getQueryStringVariable("siteId").toUpperCase();
            if(this.getQueryStringVariable("brandId") !== undefined && this.getQueryStringVariable("brandId") !== null && this.getQueryStringVariable("brandId") !== ''){
            this.window._dl.brand_id = this.getQueryStringVariable("brandId").toUpperCase();
            } else{
            this.window._dl.brand_id = "null";
            }
            this.window._dl.cyota_id = this.getCyotaId();
            this.window._dl.language = this.getQueryStringVariable("langId") || "en_US";
            this.window._dl.pid = this.getSysPrinAgent();
            this.window._dl.partnerBadge = this.getPartnerBadge();
            this.window._dl.cops = this.getCOPS();
            this.window._dl.fdr_id = this.getAccountInstanceId();
            this.window._dl.page_name = pageData.page_name;
            this.window._dl.action_type = "";
            this.window._dl.layout = "";
            this.window._dl.action_subject = "";
            this.window._dl.page_details = "";
            this.window._dl.area = "";
            this.window._dl.view = "",
            this.window._dl.module = "",
            this.window._dl.pid = "";
            this.window._dl.cops = "";
            this.window._dl_cyota_id= "";
            this.window._dl.fdr_id= "";
            this.window._dl.site_events = "";
            this.window._dl.navigation_click = "";
            this.window._dl.marketing_banner = "";
            this.window._dl.loaded_modules = "";
            this.window._dl.site_section1 = "";
            this.window._dl.page_inter = "";
            this.window._dl.product_identifier = "",
            this.window._dl.card_type= "",
            this.window._dl.flowSource = pageData.flowSource || "";
            //this.window._dl.prevPageName = null;
            this.svcService.setModuleRestarted(false);

            if (eventObject && typeof eventObject === 'object') {
                  if (eventObject.area) this.window._dl.area = eventObject.area;
                  if (eventObject.module) this.window._dl.module = eventObject.module;
                  if (eventObject.view) this.window._dl.view = eventObject.view;
                  if (eventObject.action_subject) this.window._dl.action_subject = eventObject.action_subject;
                  if (eventObject.page_inter) this.window._dl.page_inter = eventObject.page_inter;
                  if (eventObject.site_events) this.window._dl.site_events = eventObject.site_events;
                  if (eventObject.flowSource) this.window._dl.flowSource = eventObject.flowSource;
                  if (eventObject.site_section1) this.window._dl.site_section1 = eventObject.site_section1;
                  if (eventObject.page_details) this.window._dl.page_details = eventObject.page_details;
                  if (eventObject.navigation_click) this.window._dl.navigation_click = eventObject.navigation_click;
                  if (eventObject.loaded_modules) this.window._dl.loaded_modules = eventObject.loaded_modules;
                  if (eventObject.marketing_modules) this.window._dl.marketing_modules = eventObject.marketing_modules;
                  if (eventObject.test_id) this.window._dl.test_id = eventObject.test_id;
            }


            if (this.siteCatEventValueMap[<siteCatEventType>eventType]) {
                  if(this.window._dl.siteId == "PLCN_WFCC"){
                        //this._triggerService.trackBrandSpecificTag();
                        let brandID = this.getQueryStringVariable("brandId");
                        if(brandID){

                        }
                        else{

                        }
                  }
                  if (eventType == "load") {
                        this._triggerService.triggerPageLoad(eventObject);
                  }
                  else {
                        setTimeout(() => {
                              this._triggerService.invokeEventSpecificCalls(this.siteCatEventValueMap[<siteCatEventType>eventType], eventObject);
                        }, 0);
                  }
            }
            else {
                  this._triggerService.invokeEventSpecificCalls(eventType, eventObject);
            }
      }

      public attachFormSCEvents(pageData): any {
            const inputs = document.querySelectorAll('input:not([data-dropdown-sc-name="map_dropdown"])');
            this.attachEvents(inputs, pageData);
            // const dropdown = document.querySelectorAll('select');
            // this.attachEvents(dropdown, pageData);
            const anchorLink = document.querySelectorAll('a[role="link"]')
            this.attachEvents(anchorLink, pageData);
      }
      public attachEvents(inputs, pageData): void {

        for (let input of inputs) {
          if (input.type && input.type === this.siteCatFormMap["TEXT"]) {

              const subscription = fromEvent(input, 'blur').subscribe((e: any) => {
                if (e && e.target && e.target.value && e.target.value.length > 0) {
                      this.setSCPageData('formInteraction', pageData, input);
                      subscription.unsubscribe()
                };
              });

          } else {
              const subscription = fromEvent(input, 'change').subscribe((e: any) => {
                this.setSCPageData('formInteraction', pageData, input);
                subscription.unsubscribe()

              });
          }
            if (input.tagName && input.tagName === this.siteCatFormMap["ANCHOR"]) {

                    const subscription = fromEvent(input, 'click').subscribe((e: any) => {
                          this.setSCPageData('linkClick', pageData, input);
                          subscription.unsubscribe()
                    });

              }

        }
      }

      private setGlobalData(): any {
            this.globalData = this.svcService.getGlobalData();
      }

      private getPageName(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.getPageName : null;
      }

      private getCyotaId(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.cyotaID : null;
      }

      private getSysPrinAgent(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.sysPrinAgent : null;
      }

      private getCardType(): String {
            if (this.globalData && this.globalData.dataLayer && this.globalData.dataLayer.isDigital == "true")
                  return "Digital";
            return "Plastic";
      }

      private getPartnerBadge(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.partnerBadge : null;
      }

      private getCOPS(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.copsIndicator : null;
      }

      private getAccountInstanceId(): string {
            return (this.globalData && this.globalData.accountInstanceId) ? this.globalData.accountInstanceId : null;
      }

      private getQueryStringVariable(variable): String {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                  var pair = vars[i].split("=");
                  if (pair[0] == variable) {
                        return pair[1];
                  }
            }
      }
}
